import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";
export const WeChatScene = Object.freeze({
  session: 0, timeline: 1, favorite: 2,
});

export class FlutterWX extends BridgeMethod {


  constructor() {
    super();
  }

  async shareText(scene, source, {title = null} = {}) {
    return invoke('share', {params: {scene, source, title, type: 0}});
  }

  async shareImage(scene, source, {title = null} = {}) {
    return invoke('share', {params: {scene, source, title, type: 1}});
  }

  async shareFile(scene, source, {title = null} = {}) {
    return invoke('share', {params: {scene, source, title, type: 2}});
  }
}

export const flutterWX = new FlutterWX();